import React, { memo, ReactElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'reactApp/components/BaseConfirmDialog/Input/Input';
import { addEmailAction } from 'reactApp/modules/socialUser/socialUser.actions';
import { getError } from 'reactApp/modules/socialUser/socialUser.selectors';
import { Button } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './ConfirmEmailMobile.css';

export const ConfirmEmailMobile = memo(({ onClose, onSuccess }: { onClose: () => void; onSuccess: () => void }): ReactElement => {
    const dispatch = useDispatch();

    const error = useSelector(getError);

    const [email, setEmail] = useState<string>('');

    const inputRef = useRef<HTMLInputElement | null>(null);

    const afterAddEmail = useCallback(() => {
        onSuccess();
        onClose();
    }, [onClose, onSuccess]);

    const handleButtonClick = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispatch(addEmailAction(email)).then(afterAddEmail);
    }, [dispatch, email, afterAddEmail]);

    const handleInputChange = useCallback(
        (event) => {
            const { value } = event.target || {};
            setEmail(value);
        },
        [email, setEmail]
    );

    const getReference = (ref) => {
        inputRef.current = ref;
    };

    useEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        inputRef?.current?.focus?.();
    }, []);

    return (
        <MobileDialog
            id="mobile-confirm-email"
            open
            dimmer
            onClose={noopVoid}
            disableScrolling
            mod="confirm"
            topmost
            title="Подтверждение email"
            closable={false}
        >
            <div className={styles.root}>
                <div className={styles.text}>
                    Чтобы оплатить тариф, укажите свой email, и мы пришлём на указанный вами адрес ссылку для подтверждения.
                </div>
                <div className={styles.licenseBlock}>
                    Нажимая «Отправить», вы принимаете условия{' '}
                    <a href="/LA/" target="_blank">
                        Лицензионного соглашения
                    </a>
                </div>
                <Input
                    error={!!error}
                    validationErrorMessage={error}
                    onChange={handleInputChange}
                    value={email}
                    fluid
                    focus
                    autoFocus
                    getReference={getReference}
                    className={styles.input}
                    placeholder="Укажите ваш e-mail"
                />
                <div className={styles.button}>
                    <Button data-name="confirm" theme="octavius" className={styles.button} onClick={handleButtonClick} fluid primary>
                        Отправить
                    </Button>
                </div>
            </div>
        </MobileDialog>
    );
});

ConfirmEmailMobile.displayName = 'ConfirmEmailMobile';
